import { useCallback, useEffect, useMemo, useState } from "react";
import { BriefcaseBusiness } from "lucide-react";
import apiClient from "../../services/api";
import TypeAheadInput from "../shared/TypeAheadInput";

export const slugify = (s) => s.replace(/[^a-z0-9]+/gi, "-").toLowerCase();

// Shared list of contact positions/titles kept in Settings options (contact_positions).
export const useContactPositions = () => {
  const [positions, setPositions] = useState([]);
  const reload = useCallback(() => apiClient.get(`/settings/options`).then((r) => setPositions(r.data.contact_positions || [])).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  const save = useCallback(async (next) => {
    const r = await apiClient.put(`/settings/options`, { contact_positions: next });
    setPositions(r.data.contact_positions || []);
  }, []);
  return { positions, reload, save };
};

const PositionPicker = ({ value, onChange, id, testId = "contact-title", placeholder = "Project Manager, Superintendent…" }) => {
  const { positions } = useContactPositions();
  const options = useMemo(() => positions.map((name) => ({ name, icon: <BriefcaseBusiness className="w-3.5 h-3.5 text-muted-foreground shrink-0" /> })), [positions]);
  return <TypeAheadInput id={id} value={value} onChange={onChange} options={options} placeholder={placeholder} testId={testId} optionTestId={(o) => `position-option-${slugify(o.name)}`} />;
};

export default PositionPicker;
